<!--
 * @Author: baiwei
 * @Date: 2020-04-02 16:35:11
 * @LastEditors: fengzhongmei 996180799@qq.com
 * @LastEditTime: 2022-09-26 16:17:53
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="module">
        <helpInfo :helpData='helpData'></helpInfo>
        <div class="module-container set-pack">
            <!-- <h4 style="margin-top: -5px;">{{$t('安全设置')}}</h4> -->
            <Form v-if="isEdit"
                  ref="form"
                  label-position="right"
                  :model="formData"
                  :label-width="170"
                  class="form-pack">
                <div class="title">{{$t('密码策略')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('密码长度')+'：'"
                                  prop="minLength">
                            <div class="itemVal-pack">
                                <InputNumber v-model="formData.minLength"
                                             :min="1"
                                             :max="32"
                                             :precision="0"></InputNumber>
                                <span>-</span>
                                <span>32</span>
                            </div>
                        </FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('密码包含规则')+'：'"
                                  prop="charactorType">
                            <div class="itemVal-pack">
                                <span v-for="(cht, chtkey) in formData.charactorType"
                                      :key="`cht${chtkey}`"
                                      class="itemVal">
                                    {{$t(passwordNames[cht])}}
                                    <i class="icon-delete-1"
                                       @click="formData.charactorType.splice(chtkey, 1)"></i>
                                </span>
                                <span class="icon-increase-1-o"
                                      v-show="!charactorTypeAdd"
                                      @click="charactorTypeAdd=true"></span>
                                <div class="add-pack"
                                     v-show="charactorTypeAdd">
                                    <Select v-model="formData.charactorTypeSelect">
                                        <Option v-for="ptype in passwordType"
                                                :value="ptype.key"
                                                :key="ptype.key">{{ $t(ptype.desc) }}</Option>
                                    </Select>
                                    <Icon type="md-checkmark"
                                          @click="addCharactorType" />
                                    <Icon type="md-close"
                                          @click="formData.charactorTypeSelect = null;charactorTypeAdd=false" />
                                </div>
                            </div>
                        </FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('最少相异字符串')+'：'"
                                  prop="charactorLimit">
                            <InputNumber v-model="formData.charactorLimit"
                                         :max="32"
                                         :min='0'
                                         :precision="0"></InputNumber>
                            &nbsp;
                            <Tooltip placement="right"
                                     theme='light'
                                     :transfer='true'>
                                <i class="icon-prompt-1-o tips-icon-prompt"></i>
                                <div slot="content">
                                    <span>{{$t('最少相异字符串如果值设为3，那么密码至少包含3个不同的字符，例如abccba')}}</span>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('常用密码剔除')+'：'"
                                  prop="ruleOut">
                            <div class="itemVal-pack itemVal-password">
                                <span v-for="(ruleo, k) in formData.ruleOut"
                                      :key="`rl${k}`"
                                      class="itemVal">
                                    {{ruleo}}
                                    <i class="icon-delete-1"
                                       @click="formData.ruleOut.splice(k, 1)"></i>
                                </span>
                                <span class="icon-increase-1-o"
                                      v-show="!ruleOutAdd"
                                      @click="ruleOutAdd=true"></span>
                                <div class="add-pack"
                                     v-show="ruleOutAdd">
                                    <Input v-model="formData.ruleOutVal"
                                           :maxlength="32"></Input>
                                    <Icon type="md-checkmark"
                                          class="icon"
                                          @click="addRuleOut" />
                                    <Icon type="md-close"
                                          class="icon"
                                          @click="formData.ruleOutVal = null;ruleOutAdd=false" />
                                </div>
                            </div>
                        </FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('登录失败锁定')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'"
                                  prop="loginfailureEnable">
                            <i-switch size="small"
                                      v-model="formData.loginfailureEnable" />
                        </FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('最大失败次数')+'：'"
                                  prop="loginfailureCount">
                            <InputNumber v-model="formData.loginfailureCount"
                                         :min="3"
                                         :max="10"
                                         :precision="0"></InputNumber>
                            {{$t('次')}}
                        </FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('账号有效期')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'"
                                  prop="accountValidity">
                            <i-switch size="small"
                                      v-model="formData.accountValidity" />
                        </FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('有效天数')+'：'">
                            <InputNumber v-model="formData.expireTime"
                                         :min="0"
                                         :max="360"
                                         :precision="0"></InputNumber>
                            {{$t('天')}}
                        </FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('双因子认证')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'"
                                  prop="accountValidity">
                            <i-switch size="small"
                                      v-model="formData.skip2FA" />
                        </FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('密码有效期')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'"
                                  prop="accountValidity">
                            <i-switch size="small"
                                      v-model="formData.pwdExpireTimeValidity" />
                        </FormItem>
                    </li>
                    <li v-show="formData.pwdExpireTimeValidity">
                        <FormItem :label="$t('有效天数')+'：'">
                            <InputNumber v-model="formData.pwdExpireTime"
                                         :min="0"
                                         :max="360"
                                         :precision="0"></InputNumber>
                            {{$t('天')}}
                            <Tooltip placement="right"
                                     theme='light'
                                     :transfer='true'>
                                <i class="icon-prompt-1-o tips-icon-prompt"></i>
                                <div slot="content">
                                    <span>{{$t('变更有效天数不会影响已存在原用户数据，原用户数据在历史设置到期后会按照新设置生效。')}}</span>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </li>
                </ul>
            </Form>
            <Form v-else
                  label-position="right"
                  :label-width="170"
                  class="form-pack">
                <div class="title">{{$t('密码策略')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('密码长度')+'：'">{{info.minLength}}-32</FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('密码包含规则')+'：'">
                            <div class="itemVal-pack"
                                 v-if="info.charactorType&&info.charactorType.length>0">
                                <span v-for="(cht, chtkey) in info.charactorType"
                                      :key="`cht${chtkey}`"
                                      class="itemVal">
                                    {{$t(passwordNames[cht])}}
                                </span>
                            </div>
                            <div class="itemVal-pack"
                                 v-else>
                                {{$t('无')}}
                            </div>
                        </FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('最少相异字符串')+'：'">{{info.charactorLimit}}
                            &nbsp;
                            <Tooltip placement="right"
                                     theme='light'
                                     :transfer='true'>
                                <i class="icon-prompt-1-o tips-icon-prompt"></i>
                                <div slot="content">
                                    <span>{{$t('最少相异字符串如果值设为3，那么密码至少包含3个不同的字符，例如abccba')}}</span>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('常用密码剔除')+'：'">
                            <div class="itemVal-pack itemVal-password"
                                 v-if="info.ruleOut&&info.ruleOut.length>0">
                                <span v-for="(ruleo, k) in info.ruleOut"
                                      :key="`rl${k}`"
                                      class="itemVal">
                                    {{ruleo}}
                                </span>
                            </div>
                            <div class="itemVal-pack itemVal-password"
                                 v-else>
                                {{$t('无')}}
                            </div>
                        </FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('登录失败锁定')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'">{{$t(info.loginfailureEnable?'开启':'关闭')}}</FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('最大失败次数')+'：'">{{info.loginfailureCount}}
                            {{$t('次')}}
                        </FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('账号有效期')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'">{{$t(info.accountValidity?'开启':'关闭')}}</FormItem>
                    </li>
                    <li>
                        <FormItem :label="$t('有效天数')+'：'">{{info.expireTime}}
                            {{$t('天')}}
                        </FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('双因子认证')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'">{{$t(info.skip2FA?'开启':'关闭')}}</FormItem>
                    </li>
                </ul>
                <div class="title">{{$t('密码有效期')}}</div>
                <ul>
                    <li>
                        <FormItem :label="$t('开启状态')+'：'">{{$t(info.pwdExpireTimeValidity?'开启':'关闭')}}</FormItem>
                    </li>
                    <li v-show="info.pwdExpireTimeValidity">
                        <FormItem :label="$t('有效天数')+'：'">{{info.pwdExpireTime}}
                            {{$t('天')}}
                            <Tooltip placement="right"
                                     theme='light'
                                     :transfer='true'>
                                <i class="icon-prompt-1-o tips-icon-prompt"></i>
                                <div slot="content">
                                    <span>{{$t('变更有效天数不会影响已存在原用户数据，原用户数据在历史设置到期后会按照新设置生效。')}}</span>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </li>
                </ul>
            </Form>
            <div class="footer">
                <div v-if="isEdit">
                    <Button @click="isEdit = false"
                            style="width:120px;margin-right: 6px;"> {{$t('取消')}}</Button>
                    <Button type="primary"
                            style="width:120px"
                            :loading="loading"
                            :disabled="!hasPermission('CH0601')"
                            @click="submit()"> {{loading?$t('保存中'):$t('保存')}} </Button>
                </div>
                <Button v-else
                        type="primary"
                        style="width:120px"
                        :disabled="!hasPermission('CH0601')"
                        @click="initEdit"><i class="icon-edit-o"></i>&nbsp;&nbsp;{{$t('修改')}}</Button>
            </div>
        </div>
    </div>
</template>
<script>
import helpInfo from '@c/basic/helpinfo'
import API from '@/service/api.js'
export default {
    name: 'set',
    components: {
        helpInfo
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('设置')
            },
            isEdit: false,
            passwordType: [],
            formData: {},
            info: {},
            validate: {},
            passwordNames: {},
            charactorTypeAdd: false,
            ruleOutAdd: false,
            loading: false
            // initData: {}
        }
    },
    computed: {
        skip2FA_Status () {
            return !this.$store.state.user.currentOrg.skip2FA // 开始是false, 关是true
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.axios.get(this.urlFormat(API.ACCESS_PASSWORD_POLICY, false)).then(res => {
                this.info = res
                this.info.skip2FA = this.skip2FA_Status
                this.isEdit = false
            })
            this.axios.get(this.urlFormat(API.ACCESS_PASSWORD_CONFIG, false), { params: { type: 'charactorType' } }).then(res => {
                const names = {}
                for (const i in res.rules) {
                    const rule = res.rules[i]
                    names[rule.key] = rule.desc
                }
                this.passwordNames = names
                this.passwordType = res.rules
            })
        },
        initEdit () {
            this.formData = JSON.parse(JSON.stringify(this.info))
            // this.initData = JSON.parse(JSON.stringify(this.info))
            this.isEdit = true
        },
        addCharactorType () {
            const charactorTypeSelect = this.formData.charactorTypeSelect
            if (charactorTypeSelect) {
                const index = this.formData.charactorType.indexOf(charactorTypeSelect)
                index >= 0 && this.formData.charactorType.splice(index, 1)
                this.formData.charactorType.push(charactorTypeSelect)
                this.formData.charactorTypeSelect = null
            }
            this.charactorTypeAdd = false
        },
        addRuleOut () {
            const ruleOutVal = this.formData.ruleOutVal
            if (ruleOutVal) {
                const index = this.formData.ruleOut.indexOf(ruleOutVal)
                index >= 0 && this.formData.ruleOut.splice(index, 1)
                this.formData.ruleOut.push(ruleOutVal)
                this.formData.ruleOutVal = null
            }
            this.ruleOutAdd = false
        },
        submit () {
            const { minLength, skip2FA, charactorType, charactorLimit, ruleOut, loginfailureEnable, loginfailureCount, accountValidity, expireTime, pwdExpireTime, pwdExpireTimeValidity } = this.formData
            const params = {
                minLength: minLength,
                charactorType: charactorType,
                charactorLimit: charactorLimit,
                ruleOut: ruleOut,
                loginfailureEnable: loginfailureEnable,
                loginfailureCount: loginfailureCount,
                accountValidity: accountValidity,
                expireTime: expireTime,
                skip2FA: !skip2FA,
                pwdExpireTime: pwdExpireTime,
                pwdExpireTimeValidity: pwdExpireTimeValidity

            }
            // const paramsName = ['minLength', 'charactorType', 'charactorLimit', 'ruleOut', 'loginfailureEnable', 'loginfailureCount', 'loginfailureCount', 'accountValidity', 'expireTime', 'skip2FA']
            // const params = {}
            // for (const i in paramsName) {
            //     for (const j in this.initData) {
            //         if (paramsName[i] === j && String(this.formData[j]) !== String(this.initData[j])) {
            //             params[j] = this.formData[j]
            //         }
            //     }
            // }
            this.loading = true
            this.axios.put(this.urlFormat(API.ACCESS_PASSWORD_POLICY, false), params).then(res => {
                // 更新currentOrg.skip2FA
                this.$store.commit('setSkip2FA', !this.formData.skip2FA)
                this.init()
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
.set-pack {
    // background: url(./bg.png) no-repeat;

    .form-pack {
        padding-top: 10px;
        & > ul {
            display: flex;
            flex-wrap: wrap;
            padding: 5px 15px 15px 15px;
            border-bottom: 1px dashed #e9e9e9;
            & > li {
                &:nth-child(2n-1) {
                    width: 32%;
                }
                &:nth-child(2n) {
                    width: 66%;
                }
            }
        }
    }
    .itemVal-pack {
        &.itemVal-password {
            display: block;
            .itemVal {
                margin-bottom: 10px;
            }
            .add-pack {
                display: inline-block;
            }
        }
        display: flex;
        & > * {
            margin: 0 3px;
            flex-shrink: 0;
        }
        & > .icon-increase-1-o {
            font-size: 16px;
            margin-top: 8px;
            cursor: pointer;
        }
        & > .add-pack {
            i {
                display: inline-block;
                width: 32px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
                background-color: #f3f3f3;
                margin-left: 5px;
            }
        }
        .itemVal {
            display: inline-block;
            min-width: 88px;
            text-align: center;
            padding: 0 5px;
            height: 32px;
            line-height: 32px;
            background-color: #f3f3f3;
            i {
                font-size: 10px;
            }
        }
    }
    .title {
        padding: 15px;
        font-size: 12px;
    }
    .footer {
        padding: 15px;
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: #f5f6f7;
    }
}
</style>
<style lang="less">
.set-pack {
    .ivu-form-item-label {
        padding-right: 5px !important;
    }
    .ivu-input-wrapper {
        width: 86px;
    }
    .ivu-select {
        width: 100px;
    }
}
#app .module .module-container.set-pack {
    height: calc(~'100% - 110px');
}
</style>
